"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var classnames_1 = require("classnames");
var Group = /** @class */ (function (_super) {
    tslib_1.__extends(Group, _super);
    function Group(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onSelect = function (option, group) {
            if (group === void 0) { group = []; }
            var value = _this.props.value;
            var onSelect = _this.context.onSelect;
            onSelect && onSelect(option, group.concat(value));
        };
        _this.setListRef = function (el) {
            _this.list = el;
        };
        _this.onLabelClick = function () {
            if (!_this.context.multiple) {
                return;
            }
            var allItems = _this.list.querySelectorAll("div[data-selected]");
            var selectedItems = _this.list.querySelectorAll("div[data-selected=\"true\"]");
            var unselectedItems = _this.list.querySelectorAll("div[data-selected=\"false\"]");
            if (selectedItems.length > 0 && selectedItems.length < allItems.length) {
                _this.clickAllListItems(unselectedItems);
            }
            else {
                _this.clickAllListItems(allItems);
            }
        };
        _this.list = null;
        return _this;
    }
    Group.prototype.getChildContext = function () {
        return {
            onSelect: this.onSelect
        };
    };
    Group.prototype.clickAllListItems = function (items) {
        var _loop_1 = function (i, len) {
            var listItem = items[i];
            setTimeout(function () { return listItem.click(); });
        };
        for (var i = 0, len = items.length; i < len; i++) {
            _loop_1(i, len);
        }
    };
    Group.prototype.render = function () {
        var _a;
        var _b = this.props, className = _b.className, theme = _b.theme, children = _b.children, label = _b.label, value = _b.value;
        var classes = classnames_1.default(theme.group, className, (_a = {},
            _a[theme.multiple] = this.context.multiple,
            _a));
        return (React.createElement("li", { "data-value": value, className: classes },
            React.createElement("div", { className: theme.label, onClick: this.onLabelClick }, label),
            React.createElement("ul", { ref: this.setListRef, className: theme.items }, children)));
    };
    Group.defaultProps = {};
    Group.childContextTypes = {
        onSelect: PropTypes.func
    };
    Group.contextTypes = {
        onSelect: PropTypes.func,
        multiple: PropTypes.bool
    };
    return Group;
}(React.Component));
exports.default = Group;
